import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { Card, Typography, CardContent, Button } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import {dataUrl, ApiKey} from '../config.js';
import Markdown from "markdown-to-jsx";



import CssBaseline from '@mui/material/CssBaseline';
import './MuiTabs.css'

const tabsThemeLight = createTheme({
  palette: {
    mode: 'light', // can change to 'dark'
    primary: {
      main: '#0e0e0e', // Blue
    },
    secondary: {
      main: '#9c27b0', // Purple
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#4cbf6a', // use secondary color for the underline
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'activerecallbuttons' },
          style: {
            backgroundColor: '#0e0e0e',
            color: '#dedee3',
            '&:hover': { backgroundColor: '#3d3d3d' },
          },
        },]},
  },
});
const tabsThemeDark = createTheme({
  palette: {
    mode: 'dark', 
    primary: {
      main: '#dedee3', 
    },
    secondary: {
      main: '#9c27b0', 
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#4cbf6a', // use secondary color for the underline
        },
      },
    },
     MuiButton: {
      variants: [
        {
          props: { variant: 'activerecallbuttons' },
          style: {
            backgroundColor: '#e4e4e8',
            color: '#0e0e0e',
            '&:hover': { backgroundColor: '#bdbdc8' },
          },
        },]},
  },
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function SlidesViewer({ slides }) {
  const [index, setIndex] = useState(0);
  const [hintShown, setHintShown] = useState(
  Array(slides.length).fill(false)
);

  if (!slides?.length) return <Typography>No slides available.</Typography>;

  const slide = slides[index];
  const showHintForCurrent = () => {
  setHintShown((prev) => {
    const updated = [...prev];
    updated[index] = true;     // mark current slide hint as shown
    return updated;
  });
};

  return (
    <Box
      sx={{
        textAlign: "center",
        height: "100%",
        position: "relative",
      }}
    >
      <Card elevation={0} sx={{ maxWidth: '90%', margin: "auto" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {slide.question}
          </Typography>

    
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
        mt: 2,
        visibility: hintShown[index] ? "visible" : "hidden" }}
          >
            Hint: {slide.hint}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
            Type: {slide.type} | Difficulty: {slide.difficulty}
          </Typography>
        </CardContent>
      </Card>

      <Box sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 2 }}>
        <Button variant='activerecallbuttons'
          disabled={index === 0}
          onClick={() => setIndex((i) => i - 1)}
        >
          {"<Prev"}
        </Button>
        <Button
        variant="activerecallbuttons"
        disabled={hintShown[index]}
        onClick={showHintForCurrent}
      >
        Show Hint
      </Button>
        <Button variant='activerecallbuttons'
          disabled={index === slides.length - 1}
          onClick={() => setIndex((i) => i + 1)}
        >
          {"Next>"}
        </Button>
      </Box>
    </Box>
  );
}

export default function AdditionalTabs({tabIndex, subject, tK, topic}) {
  const [value, setValue] = useState(tabIndex>=0 ? tabIndex : -1);
  const [isLightMode, setIsLightMode] = useState(localStorage.getItem('islightmode') !== 'false');
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [tabContent, setTabContent] = useState({});
const [loadingMap, setLoadingMap] = useState({});

  const fetchTabContent = async (index) => {
    setLoadingMap((prev) => ({ ...prev, [index]: true }));
    try {
      var req = {
      email: localStorage.getItem('user'),
      method: index === 0 ? 'GenAISummary' :  'GenAIActiveRecall' ,
      subject: subject,
      params: {
        TK: tK,
        Topic: topic
      }
    };
    const headers = { 
      'x-api-key': ApiKey
    };
    var res = await axios.post(dataUrl, req, { withCredentials: true, headers:headers});
    let content;
    if (index === 0) {
        // Decode Base64 → UTF-8 safe
        const decoded = new TextDecoder("utf-8").decode(
          Uint8Array.from(atob(res.data), c => c.charCodeAt(0))
        );
        content = decoded || "No summary found";
      } else {
        const decoded = new TextDecoder("utf-8").decode(
          Uint8Array.from(atob(res.data), c => c.charCodeAt(0))
        );
        content = JSON.parse(decoded);
      }
      setTabContent((prev) => ({ ...prev, [index]: content }));
    } catch (err) {
      
      console.error(err);
       let message = "Error loading content. Please try again or report on +91 7995467223 or +91 9666671955";
  if (err.response) {

    const backendMsg = err.response.data?.message;

    // ✅ Show backend message if available
    if (backendMsg) {
      message = backendMsg;
    }
  }

  setTabContent((prev) => ({
    ...prev,
    [index]: message,
  }));
    } finally {
      setLoadingMap((prev) => ({ ...prev, [index]: false }));
    }
  };

  useEffect(() => {
    const handleLightModeChange = () => {
      setIsLightMode(localStorage.getItem('islightmode') !== 'false');
    };

    window.addEventListener('lightmode', handleLightModeChange);

    return () => window.removeEventListener('lightmode', handleLightModeChange);
  }, []);

  const handleChange = (event, newValue) => {
     if (newValue === 2) {
      setIsFullscreen((prev) => !prev);

      const appRoot = document.getElementsByClassName("App")[0];
      if (appRoot) {
       if (!isFullscreen) {
        appRoot.classList.add("fullscreen-active");
      } else {
        appRoot.classList.remove("fullscreen-active");
      }
      }
    } else {
      setValue(newValue);
      if (!tabContent[newValue]) {
      fetchTabContent(newValue);
    }
  }
};




  return (
    <ThemeProvider theme={isLightMode ? tabsThemeLight : tabsThemeDark}>
        <CssBaseline />
        <Box  className={`MuiTabsStyle ${isFullscreen ? "fullscreen" : ""}`}>
  
              <Tabs value={value} onChange={handleChange}>
              <Tab label="Smart AI Summary" {...a11yProps(0)} />
              <Tab label="Active Recall" {...a11yProps(1)} />
              {value>-1 && <Tab
                icon={isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                aria-label="fullscreen"
              />}
              </Tabs>
                <CustomTabPanel value={value} index={0}>
                {loadingMap[0] ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "400px",
                                      }}
                                    >
                                      <CircularProgress />
                                    </Box>
                                  ) : (
                                    <div className={'markdown' + (isFullscreen ? ' markdownfullscreen' : '') }>
                                      <Markdown>{tabContent[0] || ""}</Markdown>
                                    </div>
                                  )}
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                     {loadingMap[1] ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "400px",
                                          }}
                                        >
                                          <CircularProgress />
                                        </Box>
                                      ) : (
                                        <> {Array.isArray(tabContent[1]) ? (
                                            <div
                                              className='slides'
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "100%",
                                              }}
                                            >
                                              <SlidesViewer slides={tabContent[1]} />
                                            </div>
                                          ) : (
                                            <div style={{ textAlign: "center" }}>{tabContent[1]}</div>
                                          )}
    </>)}
                </CustomTabPanel>
            </Box>
    </ThemeProvider>
  );
}